import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc-input-textarea/input-textarea.vue";
import mobile from "./components/mobile-input-text.vue";
const info = {
    title: "长文本",
    title_i18n: "{\"zh\": \"长文本\", \"en\": \"LongText\"}",
    type: "text-multiline",
    icon: "h-icon-all-text-multiline",
    dataItemType: DataItemType.LongText,
    formControllerType: FormControlType.Textarea,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
